import { useConfigStore } from '@/stores/configStore';
import type { SystemConfig } from '@/config/serverConfig';

/**
 * Custom hook for accessing system configuration.
 * Returns the system configuration from the config store.
 */
export function useSystemConfig(): SystemConfig | null {
  return useConfigStore((state) => state.systemConfig);
}
